import React, {useState} from "react"
import {Button, Form, Modal} from "react-bootstrap"
import {FormattedMessage} from "react-intl"
import ColorDropdownButton from "../../../shortcuts/components/ColorDropdownButton"
import ActionButton from "../../../common/button/actionbutton.component"
import RowCustomStatus, {RowCustomStatusAttributes} from "../../../state/pricing/rowcustomstatus/RowCustomStatus"

type Props = {
    show: boolean
    status: RowCustomStatus | null
    onSaveCallback: (data: RowCustomStatusAttributes) => void
    onHideCallback: () => void
    onDeleteCallback: () => void
}

const DefaultStatusAttributes: RowCustomStatusAttributes = {
    name: "",
    color: "primary",
    rank: -1
}

const RowCustomStatusModal = (props: Props) => {
    const [statusAttributes, setStatusAttributes] = useState(props.status?.getAttributes() || DefaultStatusAttributes)

    const disabled = statusAttributes.name == ""
    const onSave = () => props.onSaveCallback(statusAttributes)

    return (
        <Modal show={props.show} onHide={props.onHideCallback}>
            <Modal.Header closeButton>
                <h5 className="modal-title pb-0 mb-0 border-0">
                    <FormattedMessage
                        id="pricing.row_custom_status.component.new_custom_status_modal.title"
                        defaultMessage="Create new status"/>
                </h5>
            </Modal.Header>

            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>
                        <FormattedMessage
                            id="pricing.row_custom_status.component.new_custom_status_modal.name"
                            defaultMessage="Name"/>
                    </Form.Label>

                    <Form.Control type={"text"} value={statusAttributes.name}
                        onChange={e => setStatusAttributes({...statusAttributes, name: e.target.value})}/>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>
                        <FormattedMessage
                            id="pricing.row_custom_status.component.new_custom_status_modal.colour"
                            defaultMessage="Colour"/>
                    </Form.Label>

                    <Form.Row>
                        <ColorDropdownButton
                            value={statusAttributes.color}
                            onChange={color => setStatusAttributes({...statusAttributes, color: color})}
                            className={"btn-block"}/>

                    </Form.Row>
                </Form.Group>
            </Modal.Body>

            <Modal.Footer>
                {props.status &&
                        <ActionButton type="button" className="mr-auto btn btn-danger" onClick={props.onDeleteCallback}>
                            <FormattedMessage
                                id="pricing.row_custom_status.component.new_custom_status_modal.delete"
                                defaultMessage="Delete"/>
                        </ActionButton>
                }
                <Button type="button" className="btn btn-secondary" onClick={props.onHideCallback}>
                    <FormattedMessage
                        id="pricing.row_custom_status.component.new_custom_status_modal.close"
                        defaultMessage="Close"/>
                </Button>

                <ActionButton type="button" className="btn btn-primary" onClick={onSave} disabled={disabled}>
                    <FormattedMessage
                        id="pricing.row_custom_status.component.new_custom_status_modal.save"
                        defaultMessage="Save"/>
                </ActionButton>
            </Modal.Footer>
        </Modal>
    )
}

export default RowCustomStatusModal


// WEBPACK FOOTER //
// ./src/pricing/rowcustomstatus/component/RowCustomStatusModal.tsx